{
  "account": {
    "title": "Мой аккаунт",
    "list": {
      "title": "Аккаунты",
      "description": "Список счетов-фактур связанных аккаунтов"
    },
    "form": {
      "name": {
        "title": "Имя",
        "description": "Имя вашей учетной записи"
      },
      "password": {
        "title": "Пароль",
        "description": "Установите новый пароль для вашей учетной записи, оставьте пустым, чтобы сохранить текущий пароль"
      },
      "emailPreferences": {
        "title": "Настройки электронной почты",
        "description": "Выбрать типы уведомлений по электронной почте"
      }
    },
    "billing": "Платежные реквизиты",
    "subscriptions": "Подписки",
    "manageSubscription": "Управлять подпиской",
    "popup": {
      "downgrade": "Вы уверены, что хотите понизить рейтинг? Переход на более раннюю версию вступит в силу немедленно.<br/>Обратите внимание, что вы не сможете получить скидку в течение оставшегося времени текущего платежного цикла.<br/>Новая цена плана будет применена в следующем платежном цикле.",
      "default": "Вы уверены, что хотите изменить свой план?",
      "cancel": "Вы уверены, что отмените подписку?<br/> Ваш веб-сайт будет продолжать переводиться до конца текущего периода подписки. После этого перевод будет отключен.<br/> Обратите внимание, что вы не будете иметь право на скидку за неиспользованный период.",
      "resume": "Вы уверены, что возобновите подписку?"
    }
  },
  "ai_translation": {
    "header": "Перевод с помощью искусственного интеллекта",
    "plan": {
      "header": "Цены на перевод с использованием искусственного интеллекта",
      "used": "Вы использовали {words_used} / {words_allowed} переведенных слов в своих ИИ-кредитах.",
      "remaining": "Доступные кредиты ИИ:",
      "words": "слова",
      "add_more_credits": "Добавить больше кредитов ИИ",
      "details": {
        "idiomatic_expressions": "Идиоматические и технические выражения",
        "background_translation": "Переводы в фоновом режиме",
        "page_context": "Контекст страницы и веб-сайта для перевода",
        "perfect_quality": "Отличное качество, доступная цена",
        "no_recurring": "Никаких повторяющихся платежей, предоплаченная квота",
        "save_40": "Сэкономьте 40% по сравнению с планом за 20 долларов",
        "save_50": "Сэкономьте 50% по сравнению с планом за 20 долларов",
        "best_website": "Сайт, требующий идеального качества перевода"
      },
      "quota": "{estimated_words} слов ~ {estimated_pages} страниц"
    },
    "settings": {
      "banner": {
        "title": "Перевод Linguise AI",
        "intro": "Компания Linguise рада представить Linguise AI Translation — новую премиум-функцию, использующую модели ИИ LLM (самые современные модели Llama, оптимизированные для задач перевода). Разработанная для веб-сайтов, требующих безупречной точности, эта функция учитывает контекст как страницы, так и всего веб-сайта для достижения непревзойденных результатов. Предложите своим клиентам высочайшее качество перевода, гарантируя, что их сообщение будет идеально звучать на любом языке.",
        "button": "Обновить сейчас"
      },
      "alert": {
        "description": "Эта функция не входит в ваш текущий тарифный план и требует отдельной покупки. Активируйте это дополнение, чтобы разблокировать все перечисленные ниже возможности."
      },
      "languages": {
        "title": "Применение ИИ-перевода к языкам",
        "description": "Выберите конкретный язык, на котором вы хотите использовать ИИ-перевод."
      },
      "button": {
        "save": "Сохранить настройки"
      },
      "form": {
        "rule_application": {
          "description": "Примените AI-перевод к статическому или динамическому контенту, или к обоим",
          "title": "Применить к контенту",
          "all": "Весь контент",
          "static": "Статическое содержимое",
          "dynamic": "Динамический контент"
        },
        "website_topic": {
          "title": "Тема сайта",
          "placeholder": "Суши-ресторан...",
          "description": "Определите тематику вашего веб-сайта для более качественного перевода (например, юридическая информация, суши-ресторан, интернет-магазин запчастей для велосипедов…).\nВведите тему веб-сайта на английском языке."
        },
        "apply_to_urls": {
          "title": "Применить к URL-адресам",
          "description": "Выберите конкретные URL-адреса, к которым вы хотите применить перевод ИИ.",
          "all_urls": "Все URL-адреса",
          "selected_urls": "Выбранные URL-адреса",
          "label": "URL для подачи заявки",
          "placeholder": "URL для подачи заявки",
          "wildcard": "Подстановочный знак",
          "regex": "Регулярное выражение",
          "add": "Добавить новый",
          "expression": "Тип выражения"
        },
        "apply_languages": {
          "title": "Применить к языкам",
          "description": "Выберите конкретный язык, на котором вы хотите использовать ИИ-перевод.",
          "all_languages": "Все языки",
          "selected_languages": "Выбранные языки",
          "placeholder": "Выберите языки...",
          "feedback": "Вам необходимо выбрать язык"
        },
        "enable_mode": {
          "title": "ВКЛЮЧИТЬ ИИ-ПЕРЕВОД",
          "description": "Выберите, как будет включен перевод с помощью ИИ.\nБудут применяться только следующие правила.\nТолько редактор в реальном времени позволит включить постраничный перевод из представления редактора в реальном времени.\nПравила и редактор в реальном времени будут использовать обе функции.",
          "disabled": "Неполноценный",
          "rules": "Только правила",
          "live_editor": "Только редактор в режиме реального времени",
          "all": "Правила и редактор в реальном времени"
        },
        "formality": {
          "title": "Формальность",
          "description": "Укажите степень формальности перевода, которая может быть важна для аудитории и контекста. Вариант «Нейтральный» подразумевает сохранение формальности исходного контента. Вариант «Формальный» предназначен для профессионального, делового или юридического контента (например, с использованием формальных местоимений, таких как «usted» в испанском языке). Вариант «Неформальный» предназначен для неформального, разговорного контента (например, с использованием «tú» в испанском языке).",
          "neutral": "Нейтральный",
          "formal": "Формальный",
          "informal": "Неофициальный"
        },
        "sentence_structure": {
          "classic": "Классический",
          "short": "Короткие и ёмкие предложения",
          "detailed": "Подробные и пояснительные предложения",
          "title": "Структура предложения",
          "description": "Определите предпочтительный стиль письма."
        },
        "content_purpose": {
          "marketing": "Маркетинг/реклама (убедительный, вовлекающий тон)",
          "technical": "Технический/инструктивный (ясный, точный, ориентированный на действие)",
          "support": "Поддержка клиентов (чуткая, полезная, обнадеживающая)",
          "legal": "Юридический/соответствующий требованиям (точный, формальный, недвусмысленный)",
          "educational": "Образовательный (понятный, структурированный, доступный)",
          "title": "Цель содержания",
          "description": "Определите функциональное назначение переводимого контента.",
          "other_placeholder": "Опишите цель...",
          "other": "Другое (на английском)"
        },
        "target_audience": {
          "title": "Целевая аудитория",
          "description": "Указание целевой аудитории переведенного контента (на английском языке).",
          "placeholder": "например, испаноговорящие родители, сотрудники ЕС по защите персональных данных."
        },
        "advanced": {
          "title": "Расширенные инструкции ИИ",
          "description": "Расширенные инструкции ИИ"
        },
        "override_default_translations": {
          "title": "Переопределить перевод по умолчанию",
          "description": "Если установлено значение «ДА», этот параметр принудительно выполнит перевод контента с помощью ИИ (Linguise AI), даже если он уже был переведен с помощью перевода Cloud AI (модель перевода по умолчанию)."
        },
        "force_replace_before": {
          "title": "Принудительный повторный перевод ИИ",
          "description": "Переведите с помощью ИИ заново весь контент, ИИ-перевод которого был создан до выбранной даты, например контент, переведённый старой моделью. Повторный перевод произойдёт при следующем посещении соответствующих страниц согласно правилам и использует ваши кредиты ИИ.",
          "before_date": "До даты"
        },
        "model": {
          "current": "Текущий",
          "title": "Модель",
          "description": "Выберите модель перевода LLM, которую хотите использовать",
          "load_error": "Не удалось загрузить доступные модели. Пожалуйста, повторите попытку позже.",
          "thinking_warning": "Эта модель использует высокий уровень рассуждений (\"мышление\") и будет потреблять значительно больше токенов на перевод."
        },
        "override_manual_and_selected": {
          "no_default": "Нет (по умолчанию)",
          "title": "Заменять ручные и выбранные переводы",
          "description": "По умолчанию перевод, который вы отредактировали вручную, всегда остаётся на вашем сайте, даже если создан улучшенный ИИ-перевод. Установите ДА, чтобы вместо него показывался улучшенный ИИ-перевод. Ваши ручные переводы сохраняются, и вы можете вернуться к ним в любой момент. Это также относится к повторному переводу страниц для получения новых переводов: автоматически будет использоваться самый новый перевод."
        }
      },
      "message": {
        "save_success": "Из уже переведенного контента количество страниц, которые будут улучшены с помощью перевода с помощью ИИ, составляет около {{ai_affected_urls}}.",
        "save_success_only": "Настройки успешно сохранены."
      }
    },
    "pricing": {
      "plan": {
        "title": "Заказать квоту на перевод ИИ",
        "buy_button": "КУПИТЬ ПАКЕТ ПЕРЕВОДА С ИСКУССТВЕННЫМ ИИ"
      },
      "modal": {
        "title": "Подтвердите изменение плана",
        "description": "Вы уверены, что хотите изменить свой план перевода с помощью ИИ?",
        "button_cancel": "Отмена",
        "button_confirm": "Подтверждать",
        "loading": "Пожалуйста, подождите...",
        "amount": "Количество",
        "credit": "Кредит",
        "total_due": "Итого к оплате"
      },
      "comparison": {
        "title": "Перевод с помощью Google Cloud AI против перевода с помощью Linguise AI",
        "list": {
          "0": {
            "google": "Быстрые и надежные переводы",
            "linguise": "Обрабатывать идиоматические и технические выражения"
          },
          "1": {
            "google": "Мгновенные переводы всех страниц сайта",
            "linguise": "Генерация переводов в фоновом режиме"
          },
          "2": {
            "google": "Лучшее качество, низкая цена",
            "linguise": "Отличное качество, доступная цена"
          },
          "3": {
            "google": "Лучше всего подходит для крупных веб-сайтов или сайтов с низким бюджетом",
            "linguise": "Лучше всего подходит для веб-сайтов, требующих идеального качества перевода."
          },
          "4": {
            "google": "Контекст страницы для перевода",
            "linguise": "Контекст страницы и веб-сайта для перевода"
          }
        }
      },
      "botom_banner": {
        "title": "Испытайте непревзойденную точность перевода с",
        "sub_title": "Новый ИИ-перевод Linguise",
        "description": "Linguise расширяет свои услуги автоматического перевода, представляя Linguise AI Translation — мощный новый инструмент, использующий передовые технологии перевода на основе ИИ (LLM) (новейшие модели Llama, оптимизированные для перевода). Это решение обеспечивает разработчикам веб-сайтов и веб-агентствам ещё более высокий уровень качества перевода, идеально подходящий для проектов, где идеал — это главное. Linguise AI Translation дополняет наш существующий высококачественный перевод на основе ИИ Google Cloud, предлагая вам большую гибкость и точность."
      }
    },
    "success": {
      "tab_title": "Спасибо за покупку плана AI Translation!",
      "title": "Спасибо за покупку плана AI Translation!",
      "subtitle": "Ваш план перевода с помощью искусственного интеллекта успешно приобретен!",
      "message": "Вы можете управлять своим планом перевода с помощью ИИ на странице настроек перевода с помощью ИИ.",
      "home": "Управление ИИ-переводом"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Имя",
        "description": "Имя платежного аккаунта"
      },
      "phone": {
        "title": "Телефон",
        "description": "Телефон платежного аккаунта"
      },
      "email": {
        "title": "Электронная почта",
        "description": "Электронная почта платежного аккаунта"
      },
      "address": {
        "title": "Адрес",
        "description": "Адрес платежного аккаунта",
        "city": "Город",
        "country": "Страна",
        "address1": "Адрес 1",
        "address2": "Адрес 2",
        "postal": "Почтовый индекс",
        "state": "Штат"
      },
      "tax": {
        "title": "Налоговый номер"
      }
    }
  },
  "checkouts": {
    "header": "Проверить",
    "payment_method": "Выберите способ оплаты",
    "stripe_card": "Кредитная карта (полоса)",
    "paypal": "PayPal",
    "address": {
      "new": "Введите новый платежный адрес",
      "existing": "Использовать существующий адрес"
    },
    "pay_stripe": "Подтвердите и оплатите",
    "terms": "Подтверждая подписку, вы разрешаете Linguise взимать с вас плату за будущие платежи в соответствии с нашими условиями. Вы всегда можете отменить подписку.",
    "coupon": {
      "title": "Есть купон?",
      "placeholder": "Вставьте сюда код купона",
      "apply": "Применять",
      "percent": "Скидка {{0}}%"
    },
    "add_new": "Добавить новый",
    "use_existing": "Использовать существующий способ оплаты",
    "recurring": {
      "month_single": "Оплата ежемесячно",
      "month_many": "Выставляется счет каждые {{count}} мес.",
      "year_single": "Оплата ежегодно",
      "year_many": "Выставляется счет каждые {{count}} лет",
      "day_single": "Оплата ежедневно",
      "day_many": "Счет выставляется каждые {{count}} дн.",
      "week_single": "Оплата еженедельно",
      "week_many": "Счет выставляется каждые {{count}} недель"
    },
    "add_new_no_stripe": "Добавить новую карту",
    "summary": {
      "title": "Краткое содержание",
      "subtotal": "Итого",
      "total": "Общий"
    }
  },
  "dashboard": {
    "main": {
      "title": "Панель"
    },
    "statistics": {
      "main_title": "Статистика за последние 30 дней",
      "characters": "Переведенные символы",
      "words": "Переведенные слова",
      "bandwidth": "Пропускная способность",
      "request": "Запросы",
      "page_views": "Просмотры страниц на языке (за последние 30 дней)",
      "multilingual_views": "Многоязычные просмотры страниц (за последние 30 дней)",
      "most_page_viewed": "20 самых просматриваемых страниц (за последние 30 дней)",
      "no_data_yet": "Пока нет доступных данных",
      "th_language": "Язык",
      "th_page_views": "Просмотры страниц",
      "real_visitors": "Реальные посетители",
      "crawler": "Веб-краулер"
    },
    "planHints": {
      "subscribeButton": "Подписаться",
      "upgradeButton": "Обновление",
      "usedWords": "Вы в настоящее время {words_used} слова",
      "noPlan": "Для этого домена план не активирован. Подпишитесь на план и начните переводить свой сайт",
      "trialUsage": "В настоящее время вы используете {words_used} слов из {words_allowed} слов, включенных в пробный план.",
      "trialEnds": "Пробный период на 1-й месяц активируется до {trial_ends}.",
      "subscribeMessage": "Подписывайтесь до завершения, чтобы ваш сайт всегда переводился",
      "trialReachedLimit": "Вы достигли максимального количества переведенных слов за пробный период. \nПодпишитесь на один из наших планов, чтобы продолжить перевод вашего веб-сайта.",
      "paidUsage": "Вы использовали {words_used} / {words_allowed} переведенные слова в вашем плане.",
      "paidReachedLimit": "Вы достигли максимального количества переведенных слов для текущего плана. \nОбновите план, чтобы продолжить перевод содержания вашего веб-сайта. ",
      "trialOfferedUsage": "В настоящее время вы используете {words_used} слов из {words_allowed} слов, включенных в пробный план.(Включая предложенные слова {free_words})",
      "paidOfferedUsage": "В своем плане вы использовали переведенных слов: {words_used} / {words_allowed}.(Включая предложенные слова {free_words})",
      "noPlanExtra": "Обратите внимание, что неактивные домены и их данные регулярно удаляются автоматически.",
      "planRecommended": "В зависимости от вашего текущего объема переводов рекомендуемый план:",
      "planMaximumWords": "{{words}} слова",
      "notHaveTranslatedWords": "Вы еще не сделали ни одного перевода",
      "noPlanShopify": "Для этого домена тарифный план не активирован. Оформите подписку в панели управления Shopify и начните переводить свой сайт.",
      "subscribeMessageShopify": "Подпишитесь на панель управления Shopify до ее завершения, чтобы ваш сайт был переведен"
    },
    "translationSetup": {
      "kicker": "НАСТРОЙКА ПОДДОМЕНА",
      "title": "Проверить настройки перевода",
      "description": "Проверьте DNS, переведённые хосты, доступ к исходному сайту и ограничения аккаунта.",
      "starting": "Проверка...",
      "button": "Проверить настройки",
      "viewLatest": "Показать последний результат",
      "viewCurrent": "Показать текущую проверку",
      "runAgain": "Проверить ещё раз",
      "viewDetails": "Показать подробности",
      "hideDetails": "Скрыть подробности",
      "error": "Не удалось проверить настройки",
      "allPassed": "Все проверки пройдены",
      "setupNeedsAttention": "Настройки требуют внимания",
      "setupNeedsAttentionDescription": "Одна или несколько проверок завершились с ошибкой. Проверьте пункты ниже или обратитесь в службу поддержки Linguise.",
      "lastChecked": "Последняя проверка: {{time}}",
      "domainOwnership": "Владение доменом",
      "domainOwnershipDescription": "Запись подтверждения найдена",
      "domainOwnershipFailure": "Не удалось проверить DNS-запись владения.",
      "translatedHosts": "Переведённые хосты",
      "translatedHostsDescription": "Проверено языковых хостов: {{count}}",
      "translatedHostsFailure": "Одна или несколько языковых записей CNAME указаны неверно.",
      "subdomainPage": "Страница поддомена",
      "subdomainPageDescription": "{{count}} переведённых страниц принимают HTTPS",
      "subdomainPageFailure": "Не удалось установить соединение TLS при открытии одной или нескольких переведённых страниц.",
      "originalSite": "Исходный сайт",
      "originalSiteDescription": "Проверки DNS, TLS и ответа исходного сайта",
      "originalSiteFailure": "Проверка DNS, TLS или ответа исходного сайта завершилась с ошибкой.",
      "documentationAdvice": {
        "dns": "Проверить настройки DNS",
        "tls": "Проверить настройки HTTPS",
        "origin": "Проверить настройки исходного сайта",
        "diagnostic": "Открыть инструкции по устранению неполадок"
      },
      "evidence": {
        "originDns": "Исходный DNS",
        "originTls": "Исходный TLS",
        "originHttp": "Ответ исходного сайта",
        "observedTargets": "Обнаруженные цели",
        "recordCount": "Найденные записи",
        "addressCount": "Найденные адреса",
        "statusCode": "Статус HTTP",
        "redirect": "Перенаправление",
        "expiresAt": "Срок действия сертификата истекает",
        "raw": "{{key}}",
        "noValue": "Нет значения"
      },
      "checkerError": "Не удалось завершить некоторые проверки.",
      "coreLocation": "Проверено из {{location}}",
      "status": {
        "queued": "В очереди",
        "running": "Выполняется",
        "completed": "Завершено",
        "failed": "Ошибка",
        "passed": "Пройдено",
        "warning": "Предупреждение",
        "unknown": "Неизвестно",
        "skipped": "Пропущено",
        "not_applicable": "Не применимо"
      }
    },
    "throttling": {
      "title": "Ограничение перевода",
      "description": "Временные ограничения использования",
      "unavailable": "Временные ограничения перевода недоступны",
      "window": "{{used}} / {{max}} слов",
      "resetsIn": "Сброс через {{time}}",
      "throttled": "Перевод временно приостановлен",
      "throttledDescription": "Достигнут временный лимит использования. Перевод возобновится после сброса этого периода."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "ШАГ {{step}} ИЗ {{total}}",
      "doneLabel": "ГОТОВО, ВЫ МОЖЕТЕ НАЧАТЬ ПЕРЕВОД!",
      "finish": {
        "title": "",
        "description": "Это ключ API для использования на вашем веб-сайте."
      },
      "instructions": "Инструкция по установке",
      "domainSetting": "Настройка домена",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Скрипт PHP",
        "wizardWordpressStep1": "1. Установите ",
        "wizardWordpressStep2": "\n 2. В настройках плагина скопируйте и заполните свой ключ API\n",
        "wizardWordpressStep3": "3. Вы готовы к переводу\n\n",
        "wizardWordpressStep4": "Для получения более подробной инструкции, пожалуйста, ознакомьтесь с нашей документацией: ",
        "wizardJoomlaStep1": "1. Ссылка на пакет Joomla: ",
        "wizardJoomlaStep2": "\n2. В настройках конфигурации расширения скопируйте и заполните свой ключ API",
        "wizardJoomlaStep4": "\n 4. Вы готовы к переводу\n\n",
        "wizardJoomlaStep3": "3. В конфигурации модуля установите языки, которые вы хотите отображать, и вставьте ваш модуль туда, куда вам нужно.",
        "wizardPhpStep1": "1. Скачайте наш php-скрипт здесь ",
        "wizardPhpStep2": "\n2. Следуйте инструкции по установке на странице нашей документации здесь ",
        "wizardPhpStep3": "\n3. Добавьте модуль на свои страницы.",
        "wizardPhpStep4": "\n Скопируйте следующий код и добавьте его в шапку вашей html-страницы, он автоматически отобразит модуль переключателя\n",
        "dispatchStep1": "Мы успешно отправили необходимые данные в плагин Linguise, теперь вы можете закрыть следующее окно.",
        "dispatchStep2": "Если при закрытии этого окна токен отсутствует, скопируйте следующий токен:",
        "dispatchStep3": "Вы также можете скопировать этот фрагмент, чтобы автоматически включить наш переключатель флагов.",
        "wizardOtherStep1": "Следуйте инструкциям ниже, чтобы установить Linguise на свой домен.",
        "wizardOtherStep2": "Скопируйте следующий код и добавьте его в заголовок вашей html-страницы. Модуль переключателя будет отображаться автоматически."
      },
      "trialAlreadyUsed": "Похоже, вы уже использовали бесплатную пробную версию, поэтому вам нужно получить разрешение на перевод.\nПожалуйста, подпишитесь на план или свяжитесь с нами, если вам нужно продлить пробный период.",
      "usefulLinks": "Полезные ссылки для начала работы",
      "linkDocumentation": "Документация",
      "linkExtensionDl": "Загрузить расширение",
      "linkSubscribe": "Подписаться на план сейчас",
      "linkDashboard": "Зайти в рабочую панель",
      "exclusion": {
        "title": "Названия компаний и продуктов",
        "description": ""
      },
      "finishButton": "Завершить настройку",
      "subdomains": "Субдомены",
      "subdomain_setup": "Настройка домена",
      "subdomain_auto_setup": "Подключите DNS автоматически",
      "subdomain_manual_setup": "Добавляю записи DNS самостоятельно",
      "subdomain_skip": "Добавляю записи DNS самостоятельно",
      "auto_subdomains_info": "CMS вашего конструктора сайтов требует конфигурации DNS для установки языков для каждого поддомена (например, ru.domain.com). Вы можете сделать это автоматически с помощью Entri. Просто нажмите кнопку «Подключить DNS автоматически», чтобы начать подключение к вашему DNS-менеджеру и добавить их с помощью Entri. ",
      "auto_subdomains_info_manual": "Или вы можете вручную настроить свой домен, нажав кнопку «Добавить записи DNS самостоятельно».",
      "auto_subdomains_info_2": "Вы можете сделать это автоматически с помощью Entri. Просто нажмите кнопку «Подключить DNS автоматически», чтобы начать подключение к вашему DNS-менеджеру и добавить их с помощью Entri. ",
      "breadcrumbs": {
        "step1": "Шаг 1: Домен, CMS и языки программирования",
        "step2": "Шаг 2: Язык DNS",
        "step3": "Шаг {{step}}: Инструкция по установке"
      }
    },
    "form": {
      "urls": {
        "dash": "Бросаться -",
        "underscore": "Подчеркивать _",
        "title": "Перевести URL",
        "description": "Вы хотите перевести все страницы",
        "char_description": "Символ, используемый для замены неавторизованных символов в URL-адресах",
        "advertisement_title": "⚠ Вы задали много языков.\n",
        "advertisement": "Обычно мы советуем сначала начинать переводить сайты с небольшим количеством языков. Вы будете иметь представление о том, сколько слов содержит ваш сайт. \nЭто также лучше для SEO, так как боты Google быстрее просмотрят все ваши страницы, если сначала у вас будет меньше страниц.\nЧерез неделю вы можете добавить еще несколько языков и так далее."
      },
      "url": {
        "title": "Url",
        "description": "Поместить URL своего основного домена, начиная с http:// or https://",
        "placeholder": "Доменный URL",
        "advertisement_http": {
          "title": "Вы не используете протокол https",
          "description": "Убедитесь, что ваш домен действительно не использует протокол https, который в настоящее время рекомендуется."
        },
        "advertisement_www": {
          "title": "Ваш субдомен не www",
          "description": "В большинстве случаев субдомен по умолчанию - www (например, https://www.mydomain.com). Возможно, это не ваш случай, но, пожалуйста, дважды убедитесь, что домен, который вы хотите добавить, является правильным."
        },
        "invalid_url": {
          "line1": "Нам не удалось найти ваш домен. Убедитесь, что ваш домен общедоступен через Интернет и не перенаправляется в другое место. ",
          "line2": "Если вы уверены, что ваш домен доступен, вы можете пропустить проверку домена и снова нажать кнопку «Следующий шаг».",
          "contact": "В любом случае вы можете связаться с нами по адресу",
          "force": "Пропустить проверку домена"
        },
        "invalid_subdomain_url": "Этот URL-адрес недопустим. Поддомены должны иметь вид: https://www.domain.tld или https://domain.tld без подкаталогов."
      },
      "account": {
        "title": "Аккаунт",
        "description": "Выберите аккаунт для этого домена",
        "placeholder": "Выберите аккаунт...",
        "feedback": "Вы должны выбрать аккаунт"
      },
      "platform": {
        "title": "Платформа",
        "description": "Пожалуйста, выберите платформу вашего сайта по названию CMS.",
        "learn": "Узнайте, как его выбрать",
        "placeholder": "Поиск платформы по названию CMS...",
        "info": {
          "title": "⚠ Эта платформа была добавлена недавно.\n",
          "desc": "Эта платформа для создания веб-сайтов поддерживается Linguise, хотя она была добавлена недавно. Если у вас возникли какие-либо проблемы, свяжитесь с нами по электронной почте прямой поддержки:"
        },
        "description_read_only": "Платформа, которую использует ваш сайт",
        "feedback": "Вам необходимо выбрать платформу"
      },
      "language": {
        "title": "Язык",
        "description": "Выбрать базовый язык вашего сайта",
        "placeholder": "Выбрать язык...",
        "feedback": "Вы должны выбрать язык",
        "description_read_only": "Базовый язык вашего сайта"
      },
      "token": {
        "title": "API ключь",
        "description": "Это ключ API, который нужно скопировать на свой сайт",
        "copy": "Скопировать в буфер обмена",
        "reset": "Сбросить API ключь",
        "reset_confirm": "Подтвердить сброс API ключа"
      },
      "languages": {
        "title": "Языки перевода",
        "description": "Выберите языки, на которые вы хотите, чтобы ваш веб-сайт можно было переводить.",
        "placeholder": "Выберите языки...",
        "feedback": "Вы должны выбрать язык"
      },
      "defaultRules": {
        "title": "Правила по умолчанию",
        "description": "Мы определили набор обязательных правил для улучшения перевода и предотвращения перевода нежелательного контента, например, панели инструментов WordPress.\nВы можете удалить или отредактировать эти правила позже, если захотите."
      },
      "disallow_deletion": "Вы не можете удалить домен с активной подпиской",
      "delete_confirm": "Подтвердите удаление домена",
      "delete": "Удалить домен",
      "dynamic": {
        "title": "Перевести динамический контент",
        "description": "Динамический контент, созданный с помощью запросов JavaScript и AJAX, будет переведен (этот вариант увеличит использование перевода)."
      },
      "partial_translations": {
        "title": "Разрешить частичный перевод",
        "description": "Если в вашей учетной записи достигнута квота перевода, но страница все еще требует перевода, Linguise может продолжить отображать страницу с уже переведенным содержимым. Однако некоторые части страницы останутся непереведенными, пока вы не обновите квоту. Хотя небольшое количество непереведенного контента обычно не вредит SEO, слишком большое количество непереведенного контента может негативно повлиять на пользовательский опыт. Чтобы решить эту проблему, вы можете установить пороговое значение процента непереведенного контента, разрешенного на странице. Если непереведенный контент превышает этот порог, пользователи будут автоматически перенаправлены на версию страницы на исходном языке.",
        "never": "Никогда"
      },
      "translate_error_pages": {
        "title": "Перевести страницы с ошибками",
        "description": "Linguise может перевести все страницы ошибок, однако, если ваша страница ошибок содержит динамический контент, например IP-адрес или идентификатор запроса, вам следует избегать перевода этих страниц.",
        "not_found_page": {
          "title": "Перевести страницу 404"
        },
        "error_page": {
          "title": "Перевести другие страницы ошибок"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Существующий домен найден",
          "description": "Для этого пользователя найден существующий домен. Хотите его использовать?"
        }
      },
      "search_tl": {
        "title": "Поиск переводов",
        "description": "Включите поисковые переводы для платформы вашего веб-сайта (экспериментальная опция, эта опция увеличит использование переводов)"
      },
      "shopify_promo": {
        "info": "Отличные новости! Теперь у нас есть нативное приложение для Shopify, которое вы можете установить из магазина приложений Shopify.",
        "hyperlink": "Нажмите здесь и установите Linguise из приложения.",
        "next_btn": "Перейдите в магазин Shopify, чтобы установить приложение.",
        "info_legacy": "Отличные новости! Теперь у нас есть нативное приложение для Shopify, которое вы можете установить из магазина приложений Shopify.",
        "description_legacy": "Выберите платформу \"Shopify\" вместо \"Shopify Legacy\"."
      },
      "wix_promo": {
        "info": "Отличные новости! Теперь у нас есть нативное приложение для Wix, которое вы можете установить из Wix App Market.",
        "hyperlink": "Нажмите здесь и установите Linguise из приложения.",
        "next_btn": "Перейдите в Wix App Market, чтобы установить приложение.",
        "info_legacy": "Отличные новости! Теперь у нас есть нативное приложение для Wix, которое вы можете установить из Wix App Market.",
        "description_legacy": "Выберите платформу \"Wix\" вместо \"Wix Legacy\"."
      },
      "ai_disallow_deletion": "Удалить этот домен невозможно, пока действует квота на использование ИИ. Если вы хотите удалить этот домен, пожалуйста, свяжитесь с нашей службой поддержки.",
      "language_removal": {
        "card": {
          "title": "Удалить переводы удалённых языков",
          "description": "Эти языки удалены с вашего сайта, но сохранённые переводы по-прежнему учитываются в лимите. Удалите их, чтобы вернуть слова в лимит.",
          "button": "Удалить переводы"
        },
        "hint": "Использованные слова будут возвращены в ваш лимит. Это можно делать раз в {{days}} дней для каждого сайта.",
        "modal": {
          "title": "Удалить переводы?",
          "intro": "Эти переводы будут удалены без возможности восстановления:",
          "warning": "Это действие нельзя отменить. Использованные слова будут возвращены в ваш лимит, это может занять несколько минут.",
          "limit": "Это можно делать раз в {{days}} дней для каждого сайта.",
          "confirm": "Удалить переводы"
        },
        "scheduled": "Переводы удаляются, лимит будет обновлён в ближайшее время.",
        "cooldown": "Переводы этого сайта недавно удалялись. Снова удалить их можно {{date}}.",
        "latest_completed": {
          "title": "Последнее завершённое удаление",
          "description": "Посмотрите удалённые языки и количество слов, возвращённых в лимит.",
          "languages": "Удалённые языки",
          "words_returned": "Слова, возвращённые в лимит: {{words}}",
          "completed_at": "Завершено {{date}}"
        },
        "status": {
          "recent_title": "Недавнее удаление переводов",
          "recent_description": "Следите за последним удалением и узнайте, когда станет доступно следующее.",
          "progress_title": "Ход удаления",
          "loading": "Проверяем ход удаления...",
          "unavailable": "Не удалось загрузить ход удаления. Обновите страницу и попробуйте ещё раз.",
          "label": "Статус",
          "pending": "В очереди",
          "processing": "Выполняется",
          "completed": "Завершено",
          "failed": "Ошибка",
          "unknown": "Статус недоступен",
          "percent": "Выполнено на {{percent}}%",
          "current_stage": "Текущий этап: {{stage}}",
          "processed": "Обработано записей: {{processed}}",
          "processed_total": "Обработано {{processed}} из {{total}} записей",
          "requested_at": "Запрошено {{date}}",
          "started_at": "Начато {{date}}",
          "completed_at": "Завершено {{date}}",
          "cooldown_period": "Это можно делать раз в {{days}} дней для каждого сайта.",
          "cooldown_blocked": "Пока нельзя запустить ещё одно удаление.",
          "stage": {
            "queued": "Ожидание запуска",
            "processing": "Выполняется",
            "refund_summary": "Подсчёт возвращаемых слов",
            "search_translations": "Удаление переводов поиска",
            "url_translations": "Удаление переводов URL",
            "translations": "Удаление переводов",
            "completed": "Завершено",
            "failed": "Ошибка",
            "unknown": "Выполняется"
          }
        },
        "forbidden": "У вас нет разрешения на удаление переводов."
      }
    },
    "main": {
      "edit": "Редактировать домен",
      "add": "Добавить домен",
      "wizard": "Добро пожаловать! Мастер создания нового домена",
      "common": "Домен"
    },
    "subdomains": {
      "config_ok": "DNS поддоменов настроен правильно.",
      "config_invalid": "Для работы DNS поддоменов требуется дополнительная настройка.",
      "config_check": "Конфигурация DNS поддоменов проверяется, подождите...",
      "entri_timeout": "Энтри сообщил, что время процесса распространения DNS поддоменов истекло, вам нужно будет повторить попытку еще раз или вы можете сделать это вручную.",
      "entri_process": "Ваш DNS был добавлен с помощью Entri, и его распространение обычно занимает 10–30 минут (примените все ваши языковые поддомены, например ru.domain.com). Если проверка DNS не завершится через 24 часа, вы можете обратиться в нашу службу поддержки: support@linguise.com ",
      "entri_ok": "Распространение DNS уже в пути! Ждем распространения... ",
      "infos": "Для активации трансляции необходимо добавить эти DNS-записи в записи вашего DNS-домена. После завершения нажмите кнопку проверки. Распространение DNS-записей может занять некоторое время, поэтому вам может потребоваться вернуться через несколько минут или часов.",
      "check": "Проверьте конфигурацию DNS."
    },
    "notice": {
      "broken_card": "Нам не удалось продлить ваш план на {{url}} с использованием текущего способа оплаты. Обновите свою платежную карту.",
      "quota_reached": "Ваша квота перевода для {{url}} исчерпана. Обновите страницу, чтобы возобновить перевод веб-сайта.",
      "important": "Важный",
      "quota_reached_button": "Обновите свой план сейчас",
      "broken_card_button": "Обновите свою платежную карту",
      "ai_no_subscription": "Перевод с помощью ИИ для {{url}} требует активной подписки или пробного периода. Без неё работа будет прекращена. Для продолжения выполните обновление.",
      "ai_no_subscription_button": "Обновите свой план сейчас",
      "quota_warning": "Ваша квота на перевод для {{url}} достигла {{throttling_used_percent}}%, это значение будет сброшено через {{ttl}}.",
      "locked": "Домен {{url}} в настоящее время заблокирован для переноса. Вы по-прежнему можете получить доступ к своему сайту, но не можете редактировать или добавлять новые переводы!"
    },
    "subscription": {
      "next_payment_amount": "Предстоящие платежи",
      "next_payment_date": "Следующая дата платежа",
      "invoice": {
        "header": "История счетов",
        "date": "Дата",
        "amount_due": "Количество",
        "status": "Статус",
        "actions": "Действия",
        "description": "Когда транзакции станут доступны, вы сможете просмотреть их здесь.",
        "status_text": {
          "draft": "Черновик",
          "open": "В ожидании",
          "paid": "Оплаченный",
          "uncollectible": "Несобираемый",
          "void": "Пустота",
          "failed": "Неуспешный",
          "retrying": "Повторно"
        },
        "view": "Вид",
        "empty": "Последние счета не найдены для этой подписки",
        "retry_payment": "Повторить попытку"
      },
      "next_cancellation": "Дата отмены",
      "cancel": "Отменить подписку",
      "change_plan": "Изменить план",
      "change": "Изменять",
      "suspend": "Приостановить платеж",
      "resume": "Возобновить подписку",
      "back": "Назад",
      "save": "Сохранять",
      "confirm_resume": "Вы уверены, что хотите возобновить эту подписку?",
      "confirm_cancel": "Вы уверены, что хотите отменить эту подписку?",
      "confirm_header": "Вы уверены?",
      "missing_status": "Эта подписка отсутствует",
      "not_found": "Для этого домена подписка не найдена",
      "no_payment_method": "Неизвестный",
      "remove_billing": "Удалять",
      "confirm_manual_retry": "Вы уверены, что хотите повторить этот платеж?",
      "shopify_maneged": "Эта подписка управляется Shopify. Управляйте ею через панель администратора Shopify.",
      "unknown_plan": "Неизвестный план"
    }
  },
  "domain_listing": {
    "select": "Выберите домен",
    "add": "Добавить сайт"
  },
  "editable": {
    "number": "номер {{id}}"
  },
  "footer": {
    "about": "О",
    "support": "Поддержка"
  },
  "frontendEditor": {
    "main": "Онлайн-редактор",
    "description": "Live Editor поможет вам напрямую редактировать переводы на вашем веб-сайте.",
    "button": "Открыть Live Editor",
    "language_selection": "Выбор языка перевода",
    "video_label": "Узнайте, как использовать живой редактор"
  },
  "general": {
    "403": {
      "tab_title": "Ой - ошибка 403",
      "title": "Доступ запрещен",
      "message": "Похоже, у вас нет доступа к запрошенной странице.",
      "home": "Вернуться домой"
    },
    "404": {
      "tab_title": "Ой - ошибка 404",
      "title": "Страница не найдена",
      "message": "Похоже, вы ошиблись. Не волнуйтесь ... такое случается с лучшими из нас. Вот небольшой совет, который может помочь вам вернуться на правильный путь.",
      "home": "Вернуться на домашнюю страницу"
    },
    "500": {
      "tab_title": "Ошибка 500",
      "title": "Внутренняя ошибка сервера",
      "message": "Почему бы не попробовать обновить свою страницу? или вы можете связаться с нами",
      "home": "Вернуться домой"
    },
    "fields": {
      "alert": "Некоторые поля недействительны, исправьте недопустимые поля.",
      "invalid": "Это поле недействительно",
      "phone_re": "Номер телефона недействителен",
      "phone_invalid": "Номер телефона недействителен",
      "email": "Поле электронной почты недействительно."
    },
    "saving": "Сохранение ...",
    "save": "Сохранить",
    "save_and_quit": "Сохранить и выйти",
    "invite": "Приглашать",
    "cancel": "Отменить",
    "yes": "Да",
    "no": "Нет",
    "nextStep": "Следующий шаг",
    "loading": "Подождите, пока приложение загружается",
    "goback": "Вернуться",
    "manage": "Управлять",
    "delete": "Удалить",
    "deleting": "Удаление ...",
    "table": {
      "no_data": "Здесь пока нет данных..."
    },
    "confirm": "Подтверждать",
    "unknown": "Неизвестно",
    "hide": "Скрывать",
    "show": "Показывать",
    "on": "На",
    "off": "Выключенный",
    "default": "По умолчанию"
  },
  "home": {
    "header": "Домашняя страница",
    "manage": "Управление подпиской",
    "activate_now": "Активировать сейчас",
    "activate_plan_now": "Подпишись сейчас",
    "upgrade_plan_now": "Обновите план прямо сейчас",
    "trial_message_part_1": "В настоящее время вы пользуетесь пробным планом и ",
    "trial_message_part_2": "можете активировать членство в любое время.",
    "add": "Добавить домен",
    "table": {
      "title": "Домены",
      "description": "Список ваших доменов. Нажмите на домен, чтобы управлять переводами"
    },
    "domains": {
      "empty": "У вас нет доменов в этом аккаунте"
    },
    "accountsList": {
      "title": "Аккаунты",
      "add": "Добавить новый аккаунт",
      "name": "Имя аккаунта"
    },
    "update_credit_card": "Обновите данные кредитной карты",
    "canceled": "Подписка отменена",
    "cancelling_subs": "Отмена в {{0}}",
    "resume_subscription": "Возобновить подписку",
    "shopify_managed": "Управляется Shopify",
    "trial_ends_at": "Заканчивается в {{0}}",
    "free_trial": "Бесплатная пробная версия",
    "no_subs": "Нет активной подписки"
  },
  "invoices": {
    "title": "Счета-фактуры",
    "list": {
      "title": "Список счетов-фактур"
    },
    "table": {
      "customer": "Клиент",
      "domain": "Домен",
      "amountPaid": "Выплаченная сумма",
      "status": "Статус",
      "date": "Дата",
      "invoice": "Счет-фактура",
      "pay": "Оплатить счет",
      "actions": "Действия",
      "deleted_domain": "Домен удален",
      "plan_name": "План",
      "action": "Действие"
    },
    "listPending": {
      "title": "Список счетов, ожидающих рассмотрения"
    }
  },
  "language_settings": {
    "display": "Отображение списка языков",
    "position": "Позиция",
    "display_help_text": "Показать флаг и/или названия языков. Положение переключателя языка по умолчанию может быть в любом месте содержимого или в фиксированном положении, которое остается фиксированным или перемещается при прокрутке.",
    "side_by_side": "Бок о бок",
    "dropdown": "Раскрывающийся меню",
    "popup": "Всплывающее окно",
    "flag": "Флаг",
    "lang_name": "Название языка",
    "lang_short_name": "Короткие имена",
    "positions": {
      "in_place": "На месте",
      "top_left": "Верхний левый",
      "top_left_no_scroll": "Вверху слева (без прокрутки)",
      "top_right": "В правом верхнем углу",
      "top_right_no_scroll": "Вверху справа (без прокрутки)",
      "bottom_left": "Внизу слева",
      "bottom_left_no_scroll": "Внизу слева (без прокрутки)",
      "bottom_right": "Внизу справа",
      "bottom_right_no_scroll": "Внизу справа (без прокрутки)"
    },
    "lang_names_display": {
      "title": "Отображение названий языков",
      "help_text": "В переключателе языков отображать названия языков на английском или на исходном языке, т. е. на французском или французском.",
      "english": "Английский",
      "native_languages": "Родные языки"
    },
    "flag_shape": {
      "title": "Стиль флага",
      "help_text": "Используйте круглые значки флагов svg или прямоугольные svg",
      "round": "Круглый",
      "rectangular": "Прямоугольный"
    },
    "english_flag_type": {
      "title": "Тип английского флага",
      "help_text": "Используйте флаг Великобритании или США для английского языка",
      "usa": "Флаг США",
      "great_britain": "Флаг Великобритании"
    },
    "german_flag_type": {
      "title": "Тип немецкого флага",
      "help_text": "Используйте флаг Австрии или Германии для немецкого",
      "german": "Немецкий флаг",
      "austria": "Флаг Австрии"
    },
    "spain_flag_type": {
      "title": "Тип испанского флага",
      "help_text": "Используйте флаг Мексики или Испании для испанского",
      "spanish": "Испанский флаг",
      "mexico": "Флаг Мексики",
      "peruvian": "Перуанский флаг"
    },
    "portugal_flag_type": {
      "title": "Тип португальского флага",
      "help_text": "Используйте португальский или бразильский флаг для",
      "portugal": "Португальский флаг",
      "brazil": "Бразильский флаг"
    },
    "taiwanese_flag_type": {
      "title": "Тип тайваньского флага",
      "help_text": "Используйте тайваньский или китайский флаг для тайваньцев",
      "taiwanese": "Тайваньский флаг",
      "chinese": "Китайский флаг"
    },
    "flag_border_radius": {
      "title": "Радиус границы флага (px)",
      "help_text": "Если вы используете прямоугольную форму флага, вы можете применить собственный радиус границы в пикселях."
    },
    "flag_width": {
      "title": "Размер флага (пкс)",
      "help_text": "Выберите размер флагов в пикселях. Это не меняет вес изображения, так как это формат .svg."
    },
    "lang_color": {
      "color_title": "Цвет названия языка",
      "color_help_text": "Выберите цвет текста по умолчанию для названий ваших языков",
      "hover_color_title": "Цвет при наведении названия языка",
      "hover_color_help_text": "Выберите цвет текста при наведении мыши для названий ваших языков",
      "color_popup_title": "Цвет языка всплывающего окна",
      "color_popup_help_text": "Цвет названия языка во всплывающем или раскрывающемся меню",
      "hover_color_popup_title": "Цвет всплывающего окна при наведении",
      "hover_color_popup_help_text": "Выберите цвет текста названия языка при наведении мыши во всплывающем или раскрывающемся меню"
    },
    "flag_box_shadow": {
      "shadow_title": "Тень поля флага",
      "shadow_help_text": "Цвет и размер тени для ваших языковых флажков",
      "hover_shadow_title": "Тень поля флага при наведении",
      "hover_shadow_help_text": "Цвет и размер тени для ваших языковых флажков при наведении мыши",
      "shadow_h_offset": "Смещение тени по высоте (px)",
      "shadow_v_offset": "Смещение тени по вертикали (px)",
      "shadow_blur": "Размытие теней (px)",
      "shadow_spread": "Распространение тени (пкс)",
      "shadow_color": "Цвет тени"
    },
    "order": "Порядок языков",
    "language_order_help": "Порядок языка, который будет отображаться в переключателе языков. Вы можете перетащить язык, чтобы изменить их порядок. ",
    "order_reset": "Сбросить заказ",
    "language_order_dragdrop": "Вы можете перетащить язык, чтобы изменить их порядок.",
    "popup_lang_name": "Название языка всплывающего окна",
    "preview": "Предварительный просмотр языка"
  },
  "link": {
    "form": {
      "original": {
        "title": "Оригинальный источник",
        "description": "Добавьте исходный URL-адрес ссылки и замените его ниже на язык, чтобы перевести их.",
        "srcset_description": "Вы редактируете URL-адрес изображения. Обязательно прочтите документацию, особенно если вы используете srcset или не знаете, что это такое",
        "link": "Ссылка",
        "match_link": "Режим матча",
        "match_exact": "Точный",
        "match_wildcard": "Универсальный символ",
        "match_regex": "Регулярное выражение"
      },
      "alternative_languages": {
        "title": "Ссылки на замену",
        "description": "Замените медиа-ссылки и внешние ссылки на всех ваших страницах по языку…",
        "link": "Ссылка на замену"
      },
      "error": {
        "atLeastOne": "Пожалуйста, добавьте хотя бы один перевод.",
        "url": "URL-адрес недействителен",
        "extension": "Ссылка должна иметь расширение, но не .html или .php. И ссылка не должна содержать какой-либо языковой путь, например. \"/fr\"",
        "regex": "Регулярное выражение недействительно.",
        "wildcard": "Ссылка с подстановочным знаком имеет недопустимый протокол"
      }
    },
    "main": {
      "parent": "Ссылки",
      "edit": "Изменить ссылку"
    }
  },
  "links": {
    "title": "Управление СМИ и внешними ссылками",
    "description": "Перечислите и отредактируйте медиа-ссылки или внешние ссылки на своем веб-сайте.",
    "add": "Добавить ссылку ",
    "delete": "Удалить ссылку",
    "table": {
      "original": "Оригинал",
      "language": "Язык",
      "translation": "Перевод",
      "action": "Действие",
      "delete_confirm": "Пожалуйста, подтвердите удаление ссылки"
    }
  },
  "members": {
    "header": "Участники",
    "invite": "Пригласить нового участника",
    "modal": {
      "inviteHeader": "Пригласить нового участника",
      "editHeader": "Редактировать участника",
      "detachHeader": "Отсоединить участника",
      "detachBody": "Вы уверены, что хотите отсоединить участника от этой учетной записи?",
      "selfDetachBody": "Вы уверены, что хотите отстраниться от управления этим аккаунтом? После этого вы не сможете получить доступ ни к каким данным, связанным с этой учетной записью. "
    },
    "table": {
      "title": "Список участников",
      "description": "Роли участников и доступ к доменам",
      "name": "Имя",
      "email": "Электронная почта",
      "websites": "Веб-сайты",
      "languages": "Языки",
      "role": "Роль",
      "status": "Статус",
      "resendInvite": "отправить",
      "inviteSent": "приглашение было отправлено",
      "actions": "Действия",
      "edit": "Редактировать",
      "detach": "Отсоединить",
      "empty": "У вас пока нет участников",
      "all_website": "Все сайты и языки",
      "roles": {
        "admin": "Администратор",
        "manager": "Менеджер",
        "translator": "Переводчик"
      },
      "statuses": {
        "pending": "В ожидании",
        "accepted": "Принято",
        "declined": "Отклонено"
      }
    },
    "errors": {
      "role": "Вам необходимо выбрать роль",
      "domains": "Вы должны выбрать хотя бы 1 веб-сайт для выбранной роли.",
      "languages": "Вы должны выбрать хотя бы 1 язык для выбранных веб-сайтов."
    },
    "inviteSent": "Ваше приглашение успешно отправлено"
  },
  "pagination": {
    "showing": "Показ {{limit}}  {{total}} результатов",
    "showing_only_count": "Показ {{limit}} результатов"
  },
  "payments_method": {
    "header": "Способы оплаты",
    "table": {
      "title": "Список способов оплаты",
      "description": "Прикрепленные способы оплаты к вашему аккаунту",
      "default": "По умолчанию",
      "action_edit_remove": "Изменить или удалить",
      "action_remove": "Удалять",
      "action_default": "Установить по умолчанию",
      "action_fallback": "Установить как запасной вариант",
      "expires": "Срок действия истекает",
      "add_new_card": "Добавить способ оплаты",
      "action_fallback_remove": "Удалить из резервного варианта",
      "fallback": "Отступать",
      "action_edit": "Редактировать",
      "action_delete": "Удалить",
      "action_default_remove": "Удалить по умолчанию",
      "domain_count@@one": "Используется домены {{count}}",
      "domain_count@@other": "Используется доменами {{count}}"
    },
    "paypal_bind": {
      "button": "Подключить учетную запись PayPal",
      "button_load": "Подключение...",
      "disconnected": "Не подключено",
      "error": "Произошла ошибка",
      "success_header": "Успех",
      "success_no_promo": "Ваша учетная запись PayPal теперь подключена",
      "success": "Ваша учетная запись PayPal теперь подключена, из вашего следующего счета будет снято 5 долларов США!"
    },
    "card_add": {
      "header": "Добавить новую карту",
      "success": "Подключил новую карту к Linguise!",
      "terms": "Предоставляя данные своей карты, вы разрешаете Linguise снимать средства с вашей карты для будущих платежей в соответствии с нашими условиями обслуживания."
    },
    "card_detail": {
      "header": "Информация о карте",
      "delete": {
        "error": "Вы не можете удалить этот способ оплаты, поскольку на него есть активные подписки!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Подписки по этому способу оплаты",
        "header_domain": "Домен",
        "header_plan": "План",
        "header_status": "Статус",
        "header_actions": "Действия",
        "cancelling": "Отмена в: {{0}}",
        "next_payment": "Следующий платеж: {{0}}",
        "action_renew": "Продлить",
        "no_subs_header": "Нет подписок для отображения",
        "no_subs_desc": "После оформления подписки на эту карту вся информация будет отображаться здесь.",
        "action_manage": "Управлять"
      },
      "status": {
        "active": "Активный",
        "canceled": "Отменено",
        "incomplete": "Неоплачиваемый",
        "incomplete_expired": "Неоплаченный (истёк)",
        "past_due": "Просроченный платеж",
        "trialing": "Пробный",
        "unpaid": "Неоплачиваемый",
        "missing": "Ошибка"
      }
    },
    "delete_confirm_body": "Вы уверены, что хотите удалить этот способ оплаты? Это действие невозможно отменить!",
    "delete_confirm_header": "Удалить способ оплаты?",
    "card_edit": {
      "header": "Редактировать карточку",
      "billing_header": "Платежная информация",
      "address_error": "Адрес обязателен!",
      "card_number": "Номер карты",
      "card_expiry": "Дата окончания срока",
      "expiry_error_month": "Указан неверный месяц",
      "expiry_error_year": "Указан неверный год",
      "expiry_error_expired": "Год окончания срока действия вашей карты уже в прошлом.",
      "card_header": "Информация о карте",
      "expiry_error_empty": "Это поле обязательно к заполнению!"
    }
  },
  "plans": {
    "per": "в",
    "wordsTranslated": "слова переведены",
    "current": "Текущий",
    "archived": "Архивировано",
    "day": "день",
    "week": "неделя",
    "month": "месяц",
    "year": "год",
    "activate": "Активировать",
    "cancel": "Отменить",
    "change": "Изменить",
    "upgrade": "Обновить",
    "downgrade": "Понизить",
    "notEnoughWords": "Недостаточно слов",
    "yearIntervalOnly": "Невозможно перейти с годового плана",
    "wordsUnlimited": "Неограниченное количество слов",
    "tabs": {
      "day": "Ежедневные цены",
      "week": "Еженедельные цены",
      "month": "Ежемесячные цены",
      "year": "Годовые цены",
      "sub_texts": {
        "day": "Одна фиксированная цена, каждый день",
        "week": "Одна фиксированная цена, каждую неделю",
        "month": "Одна фиксированная цена, каждый месяц",
        "year": "Один месяц бесплатно, один счет в год"
      }
    },
    "details": {
      "new_languages": "Добавляйте новые языки в любое время",
      "one_month_trial": "Месяц бесплатной пробной версии для каждого нового сайта",
      "multi_content_indexed": "Индексируется 100 % многоязычного контента",
      "translate_new_content": "Мгновенно переводите новый контент",
      "free_installation": "Бесплатная установка и настройка",
      "compared_monthly_plan": "Один месяц бесплатно по сравнению с ежемесячными планами",
      "risk_free_recurring": "Безрисковый отказ регулярного платежа",
      "unlimited_languages": "Неограниченное количество языков и просмотров страниц",
      "high_server_resources": "Высокие ресурсы сервера",
      "billed": {
        "day": "Оплата ежедневно",
        "week": "Оплата еженедельно",
        "month": "Оплата ежемесячно",
        "year": "Оплата ежегодно"
      },
      "request_max_size": "Максимальный размер запроса {{0}}"
    },
    "frequent_question": {
      "title": "Частые вопросы",
      "questions": {
        "trial": {
          "question": "Могу ли я использовать пробную версию на новом домене веб-сайта?",
          "answer": "Да, мы предлагаем 30-дневную бесплатную пробную версию для каждого нового домена веб-сайта, который вы добавляете в свою учетную запись. Таким образом, вы сможете полностью протестировать услугу перевода на своем новом веб-сайте."
        },
        "seo": {
          "question": "Сколько времени потребуется, чтобы мое SEO улучшилось?",
          "answer": "Контенту и многоязычному контенту требуется время, чтобы полностью проиндексироваться и получить хороший рейтинг. В зависимости от посещаемости и размера вашего сайта этот срок составляет от 3 до 6 недель."
        },
        "quota": {
          "question": "Включены ли человеческие переводы в квоту?",
          "answer": "Нет, ограничение на количество слов действует только для автоматических машинных переводов. Переводчик может редактировать автоматические переводы вручную без ограничений."
        }
      }
    },
    "best_offer": "Лучшее предложение",
    "resume": "Резюме",
    "subsCanceled": "Выполняется еще одна отмена подписки",
    "period": {
      "days@@one": "день",
      "days@@other": "{{count}} Дни",
      "hours@@one": "час",
      "hours@@other": "{{count}} часы",
      "minutes@@one": "минута",
      "minutes@@other": "{{count}} минуты",
      "seconds@@one": "второй",
      "seconds@@other": "{{count}} секунды"
    },
    "words": {
      "billion": "{{value}} млрд",
      "million": "{{value}} млн",
      "thousand": "{{value}} тыс."
    },
    "throttling_info": "{{words}} слова за {{period}}"
  },
  "profile": {
    "welcome": "Добро пожаловать!",
    "account": "Мой счет",
    "subscriptions": "Подписки",
    "logout": "Выйти"
  },
  "register": {
    "errors": {
      "password": "Минимум 8 символов, любой символ"
    }
  },
  "route": {
    "dashboard": "Панель",
    "rules": "Правила",
    "translations": "Переводы",
    "search_translations": "Поиск переводов",
    "urls_translations": "Перевод URL-адресов",
    "links": "Медиа и внешние ссылки",
    "online_editor": "Живой редактор",
    "settings": "Настройки",
    "domain": {
      "finish": "Настройки",
      "preconfig": "Настройки"
    },
    "home": "Главная",
    "domain_list": "Список доменов",
    "members": "Участники",
    "invoices": "Счета-фактуры",
    "billing": "Платежные реквизиты",
    "language_display": "Отображение языковых флагов",
    "payment_methods": "Способы оплаты",
    "ai_translation": "Перевод с помощью ИИ",
    "ai_translation_settings": "Настройки",
    "ai_translation_pricing": "Цены"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Текст для игнорирования",
        "add": "Добавить новый",
        "title": "Текст для игнорирования",
        "description": "Добавить один или несколько текстов, которые нужно игнорировать",
        "ignore_case": "Игнорировать случай"
      },
      "html_content": {
        "title": "Применить к содержимому html",
        "description": "Применить правило ко всему контенту или выбрать определенный селектор CSS.",
        "all_page": "Вся страница",
        "css_selector": "CSS селектор",
        "label": "CSS  селектор",
        "placeholder": "Селектор для применения к",
        "add": "Добавить новый"
      },
      "apply_to_urls": {
        "title": "Применить к URL",
        "description": "Выберите определенные URL-адреса, к которым вы хотите применить правило",
        "all_urls": "Все URL",
        "selected_urls": "Выбранные URL",
        "label": "URL для обращения к",
        "placeholder": "URL для обращения к",
        "original_url": "Исходные URL",
        "translated_url": "Переведенный URL",
        "wildcard": "Подстановочный знак",
        "regex": "Регулярное выражение",
        "add": "Добавить новый",
        "expression": "Тип выражения"
      },
      "apply_urls": {
        "title_exclude": "Исключить в URL",
        "title_replace": "Заменить в URL",
        "title_description": "Также применить это правило к переводу URL-адресов"
      },
      "apply_languages": {
        "title": "Применить к языкам",
        "description": "Выберите конкретный язык, на котором вы хотите применить правило",
        "all_languages": "Все языки",
        "selected_languages": "Выбранные языки",
        "placeholder": "Выберите языки...",
        "feedback": "Вы должны выбрать язык"
      },
      "name": {
        "title": "Заголовок",
        "description": "Дайте своему правилу название для удобства",
        "placeholder": "Название правила"
      },
      "type": {
        "title": "Вид",
        "description": "Выберите тип правила, которое хотите добавить",
        "text_ignore": "Текст игнорировать",
        "text_replace": "Текст для замены",
        "content_exclusion": "Исключение контента",
        "url_exclusion": "Исключение перевода URL",
        "ignore_inline": "Игнорировать встроенный",
        "full_description": {
          "text_ignore": "Добавьте правила, чтобы избежать перевода текста. Это может быть название вашего продукта, торговая марка или другие технические элементы, которые вы не хотите переводить. ",
          "text_replace": "Замена текста позволяет заменить некоторый текст желаемым переводом, это может быть нужно, когда перевод игнорирует контекст.",
          "content_exclusion": "Исключение контента поможет вам избежать перевода некоторого контента на странице. \n Если вы хотите полностью исключить страницу из перевода (без многоязычного URL-адреса для этой страницы и без переведенного контента), используйте \"Исключение перевода URL-адресов \" тип",
          "url_exclusion": "Исключение перевода страниц поможет вам указать страницы, которые вы не хотите переводить.",
          "ignore_inline": "Избегайте перевода некоторого контента как встроенного, вместо этого переводите каждый тег отдельно."
        }
      },
      "text_replace": {
        "title": "Текст для замены",
        "description": "Заменить некоторый текст на ваш особый перевод. Заменить любой текст на всех ваших страницах на язык â€¦",
        "text_to_replace": "Текст для замены",
        "ignore_case": "Игнорировать случай",
        "text_type": "Замена в переводе",
        "text_type_original": "Оригинал",
        "text_type_translation": "Перевод",
        "keep_case": "Постарайтесь сохранить случай",
        "add": "Добавить новый"
      },
      "content_exclusion": {
        "title": "Исключение контента",
        "description": "Выбрать один или несколько селекторов CSS, которые не будут переведены",
        "label": "CSS селектор",
        "placeholder": "Селектор для применения к",
        "add": "Добавить новый"
      },
      "multilingual_url": {
        "title": "Use Используйте многоязычный URL-адрес",
        "description": "Если установлен режим «Да», URL-адрес НЕ будет переведен, но страница останется многоязычной с переведенным контентом.",
        "live_example_title": "Живой пример",
        "live_example_description": "Источник URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Сгенерированный UR: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Сгенерированный URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Применить правило на статическом содержании или динамическом содержании или оба",
        "title": "Применить к контенту",
        "all": "Весь контент",
        "static": "Статическое содержание",
        "dynamic": "Динамический контент"
      },
      "force_apply_urls": {
        "title_description": "Сила применить это правило ко всем переводу URL -адресов, включая существующие переводы!",
        "title_replace": "Заменить замену в URL",
        "title_exclude": "Сила исключить в URL",
        "warning": "Предупреждение",
        "warning_part1": "Установка этого на «Да» может сломать переводы на URL вашего сайта.",
        "warning_part2": "Это может временно или навсегда генерировать страницу 404S, пожалуйста, продолжайте только в том случае, если вы понимаете последствия.",
        "warning_replacement_original": "Дополнительное предупреждение: вы пытаетесь заменить оригинальный контент, который может повлиять на URL, перевод может потерпеть неудачу, поскольку лингвизация не может правильно найти исходные URL"
      }
    },
    "main": {
      "parent": "Плавила",
      "edit": "Редактировать правило",
      "add": "Новое правило"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" будет игнорироваться в содержании и and в URL",
      "preview_single": "\"{{text_ignore}}\" будет игнорироваться в содержании",
      "preview_more_with_url": "\"{{text_ignore}}\" и {{count}} более будет игнорироваться в содержании",
      "preview_more": "\"{{text_ignore}}\" и {{count}} более будет игнорироваться в содержании",
      "other_parameters": "Для этого правила установлены другие параметры, нажать кнопку редактирования, чтобы получить дополнительную информацию."
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" заменен на  \"{{replacement}}\" в содержании и URL",
      "preview_single": "\"{{original}}\" заменен на  \"{{replacement}}\" в содержании",
      "preview_more_with_url": "\"{{original}}\" заменен на \"{{replacement}}\" в содержании и URL, и {{nb}} более",
      "preview_more": "\"{{original}}\" заменен на  \"{{replacement}}\" в содержании и {{nb}} более",
      "other_parameters": "Для этого правила установлены другие параметры, нажать кнопку редактирования, чтобы получить дополнительную информацию."
    },
    "content_exclusion": {
      "selectors": "{{nb}} Селектор (ы) CSS исключен(чены) из перевода",
      "other_parameters": "Для этого правила установлены другие параметры, нажать кнопку редактирования, чтобы получить дополнительную информацию."
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL-адреса исключаются из перевода, но при этом сохраняется многоязычный префикс.",
      "some": "{{nb}} URL-адреса полностью исключены из перевода",
      "all_multilingual": "все URL-адреса исключены из перевода, но при этом сохраняется многоязычный префикс",
      "all": "все URL-адреса полностью исключены из перевода",
      "other_parameters": "Для этого правила установлены другие параметры, нажать кнопку редактирования, чтобы получить дополнительную информацию."
    },
    "ignore_inline": {
      "elements": "Все встроенное содержимое будет переведено как содержимое блоков на странице.",
      "all_elements": "Некоторый встроенный контент будет переведен как блочный контент на странице.",
      "other_parameters": "Для этого правила заданы и другие параметры; нажмите кнопку «Редактировать», чтобы получить дополнительную информацию."
    },
    "title": "Управление правилом",
    "description": "Управлять исключениями и заменой содержимого переводов на всем вашем веб-сайте",
    "add": "Добавить новое правило",
    "table": {
      "title": "Заголовок",
      "type": "Вид",
      "preview": "Предварительный просмотр правила",
      "action": "Действие",
      "delete_confirm": "Подтвердите удаление правила",
      "types": {
        "text_ignore": "Игнорировать текст",
        "text_replace": "Замена текста",
        "content_exclusion": "Исключение контента",
        "url_exclusion": "Исключение URL",
        "ignore_inline": "Игнорировать встроенный",
        "unknown": "Неизвестное правило"
      },
      "no_data": "Здесь пока нет правил"
    },
    "apply_on_content": {
      "static": "Это правило будет применяться только к статическому контенту.",
      "dynamic": "Это правило будет применяться только к динамическому контенту."
    }
  },
  "search_translations": {
    "title": "Управление поисковыми переводами",
    "description": "Перечислите все переводы вашего веб-сайта, используемые через формы поиска (с переведенного языка на базовый язык вашего домена)",
    "filter_languages": "Отфильтровать текст на исходном языке...",
    "filter_original": "Отфильтровать текст на исходном языке",
    "filter_translation": "Фильтр по переведенному тексту",
    "table": {
      "original": "Оригинал",
      "language": "Язык",
      "translation": "Перевод"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Не удалось подписаться!",
      "title": "Не удалось подписаться!",
      "subtitle": "При попытке оформить подписку произошла ошибка.",
      "home": "Вернись домой",
      "generic": "На стороне Linguise произошла неизвестная ошибка, свяжитесь с администратором!"
    },
    "success": {
      "home": "Управление переводами доменов",
      "message": "Мы стремимся предоставить вам наилучший опыт перевода. Наша команда экспертов готова помочь вам с любыми вопросами или оказать поддержку, которая может вам понадобиться. Чтобы начать, просто нажмите на кнопку ниже.",
      "subtitle": "Благодарим Вас за выбор услуги перевода Linguise.",
      "title": "Подписка активирована!",
      "tab_title": "Спасибо за подписку!"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "Управлять подпиской"
    },
    "list": {
      "title": "Список подписок",
      "description": "Список подписок вашего домена"
    },
    "table": {
      "domain": "Домен",
      "plan": "План",
      "status": "Статус",
      "card": "Карта",
      "usage": "Использование",
      "actions": "Действия",
      "payment_method": "Способ оплаты"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} слов",
      "paidOffered": "{{words_used}} / {{words_allowed}} слов\n(Включено предложенных слов: {{free_words}})"
    },
    "success": {
      "tab_title": "Подписка активирована!",
      "title": "Подписка активирована!",
      "subtitle": "Благодарим Вас за выбор услуги перевода Linguise.",
      "message": "«Мы стремимся предоставить вам наилучший опыт перевода. Наша команда экспертов готова помочь вам с любыми вопросами или оказать поддержку, которая может вам понадобиться. Чтобы начать, просто нажмите на кнопку ниже.",
      "home": "Управление переводами доменов"
    },
    "popup": {
      "dueToday": "Итого к оплате сегодня",
      "nextPeriod": "Начиная с {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Выберите аккаунт"
    }
  },
  "translation": {
    "main": {
      "parent": "Переводы",
      "edit": "Редактировать перевод"
    },
    "form": {
      "original": {
        "title": "Оригинал на {{language}}"
      },
      "is_inline": "Этот перевод сделан из встроенного контента.",
      "inline_editor": {
        "count_warning": "Количество встроенных областей не совпадает с оригиналом ({{current}} из {{expected}}).",
        "restore_original": "Восстановить исходный текст",
        "insert_placeholder": "Вставить заполнитель",
        "drag": "Перетащите, чтобы изменить порядок области",
        "area": "Встроенная область {{index}}",
        "restore": "Восстановить отсутствующие встроенные области"
      },
      "translation": {
        "title": "Перевод на {{language}}",
        "description": "Перевод, который вы хотите переопределить"
      }
    },
    "copy": {
      "title": "Скопировать в ручной перевод",
      "label": "В ручной перевод"
    },
    "level": {
      "base": {
        "title": "Базовый перевод",
        "subtitle": "Автоматический · перевод Linguise Cloud",
        "empty": "Для этого текста нет базового перевода.",
        "overridden": "Ваш выбор сохранён, но вместо него показывается самый новый улучшенный ИИ-перевод, так как в настройках ИИ-перевода параметр «Заменять ручные и выбранные переводы» имеет значение Да. Отключите этот параметр, чтобы использовать ваш выбор."
      },
      "not_generated": "Не создан",
      "none": "Пока ничего",
      "ai": {
        "title": "Улучшенный ИИ-перевод",
        "subtitle": "Автоматический · Linguise AI",
        "empty_title": "Для этого текста ещё не создан",
        "empty_description": "Linguise AI создаёт более естественные переводы, учитывая контекст вашей страницы и сайта. Чтобы получить такой перевод:",
        "empty_step_1": "Откройте ИИ-перевод › Настройки и установите для параметра «Включить ИИ-перевод» значение «Только правила», «Только редактор в режиме реального времени» или «Правила и редактор в реальном времени».",
        "empty_step_2": "Примените его с помощью правила, подходящего для этой страницы, или включите постранично в Live Editor.",
        "empty_step_3": "Улучшенный ИИ-перевод появится здесь после создания. Он расходует ваши ИИ-кредиты.",
        "open_settings": "Открыть настройки ИИ-перевода",
        "open_editor": "Открыть Live Editor",
        "overrides_selection": "Ваш выбор сохранён, но вместо него показывается этот улучшенный ИИ-перевод, так как в настройках ИИ-перевода параметр «Заменять ручные и выбранные переводы» имеет значение Да. Отключите этот параметр, чтобы использовать ваш выбор.",
        "overrides_version": "Выбранная вами версия сохранена, но вместо неё показывается самая новая улучшенная ИИ-версия, так как в настройках ИИ-перевода параметр «Заменять ручные и выбранные переводы» имеет значение Да. Отключите этот параметр, чтобы использовать выбранную версию."
      },
      "manual": {
        "title": "Ручной перевод",
        "subtitle": "Написан вами · приоритетнее автоматических переводов",
        "empty": "Пусто",
        "saved_but_overridden": "Сохранён как ваш выбор, но автоматически не показывается, так как в настройках ИИ-перевода параметр «Заменять ручные переводы» имеет значение Да: улучшенный ИИ-перевод имеет приоритет, пока этот параметр не отключён.",
        "ignored": "Автоматически не показывается, так как в настройках ИИ-перевода параметр «Заменять ручные переводы» имеет значение Да. Выберите его, чтобы использовать для этого текста.",
        "label": "Ваш перевод",
        "placeholder": "Введите свой перевод...",
        "last_updated": "Изменён: {{date}}",
        "save_hint": "После сохранения ручной перевод становится активным.",
        "delete": "Удалить ручной перевод",
        "delete_confirm": "Пожалуйста, подтвердите удаление ручного перевода"
      }
    },
    "history": {
      "title": "Улучшенные ИИ-версии",
      "subtitle": "Каждая повторная генерация из Live Editor сохраняется",
      "unknown_model": "Неизвестная модель",
      "current": "Текущая",
      "restore": "Восстановить эту версию",
      "restore_note": "После восстановления эта версия становится текущим улучшенным ИИ-переводом. Ничего не удаляется.",
      "version_of": "Версия {{current}} из {{total}}",
      "hide": "Скрыть историю ({{total}})",
      "show": "Показать историю ({{total}})"
    },
    "choose": {
      "title": "Переводы на {{language}} · выберите тот, который видят посетители",
      "current": "Сейчас на вашем сайте:",
      "priority": "Приоритет по умолчанию: ручной › улучшенный ИИ › базовый. Ваш выбор сохраняется только для этого перевода.",
      "reset": "Вернуть приоритет по умолчанию",
      "reset_title": "Забыть ваш выбор для этого текста и снова использовать приоритет по умолчанию",
      "resetting": "Сброс ..."
    }
  },
  "translations": {
    "title": "Управление переводами",
    "description": "Перечислить и отредактировать все переводы вашего веб-сайта, для визуального перевода использовать Live Editor.",
    "filter_languages": "Отфильтровать текст на исходном языке...",
    "filter_original": "Отфильтровать текст на исходном языке",
    "filter_translation": "Фильтр по переведенному тексту",
    "table": {
      "original": "Оригинал",
      "language": "Язык",
      "action": "Действие",
      "base": "Базовый",
      "ai": "Улучшенный ИИ",
      "manual": "Ручной"
    },
    "filter_exact": "Точное совпадение",
    "badge": {
      "active": "Активен",
      "overrides_manual": "Заменяет ручной"
    },
    "cell": {
      "none": "нет",
      "not_generated": "не создан",
      "ignored": "Игнорируется – приоритет у ИИ-правила"
    },
    "tabs": {
      "all": "Все",
      "manual": "С ручным",
      "ai": "С улучшенным ИИ",
      "base": "Только базовый"
    },
    "levels_hint": "У каждого текста до 3 уровней — тот, что отмечен как «Активен», видят посетители."
  },
  "url": {
    "main": {
      "parent": "URL",
      "edit": "Изменить перевод URL"
    },
    "form": {
      "original": {
        "title": "Оригинал на {{language}}"
      },
      "translation": {
        "title": "Перевод URL на {{language}}",
        "description": "URL, который вы хотите переопределить",
        "placeholder": "Переопределение перевода URL",
        "invalid_full": "Вы пытаетесь изменить неправильный формат, вам следует изменить только слаги/путь перевода URL-адреса.",
        "invalid": "Указан неверный URL/путь."
      }
    }
  },
  "urls": {
    "title": "Управление URL-адресами",
    "description": "Перечислить и отредактировать переведенный контент всех URL-адресов вашего веб-сайта (дополнительно, остерегайтесь ошибок 404)",
    "filter_languages": "Фильтр по языкам...",
    "filter_original": "Отфильтровать текст на исходном языке",
    "filter_translation": "Фильтр по переведенному тексту",
    "table": {
      "original": "Оригинал",
      "language": "Язык",
      "url": "Переведенный URL",
      "action": "Действие",
      "edited": "Оригинальный перевод отредактирован"
    }
  }
}
